import Model from 'flarum/common/Model';
/** Uma concessão (`/api/canela-user-badges`): quem ganhou, qual emblema, por qual postagem. */
export default class UserBadge extends Model {
  grantedAt() {
    return Model.attribute('grantedAt', Model.transformDate).call(this);
  }
  /** Motivo ou link de uma concessão manual. */
  reason() {
    return Model.attribute('reason').call(this);
  }
  user() {
    return Model.hasOne('user').call(this);
  }
  badge() {
    return Model.hasOne('badge').call(this);
  }
  post() {
    return Model.hasOne('post').call(this);
  }
}
flarum.reg.add('ramon-canela', 'forum/features/badges/models/UserBadge', UserBadge);